import moment from 'moment-timezone'
import api from '@/services/api'

export const state = () => ({
  searchQuery: {
    dateTime: [],
    capacity: '4-6',
    meetingRoom: 'ALL'
  },
  searchResult: null,
  confirmBookingRoomInfo: null,
  myBookingList: [],
  currentBooking: null,
  roomList: [],
  calendar: [],
  localCalendar: [],
  zoneList: [],
  myBookingStatus: null,
  myBookingQuota: null
})
export const getters = {
  searchQuery (state) {
    return state.searchQuery
  },
  searchResult (state) {
    return state.searchResult
  },
  confirmBookingRoomInfo (state) {
    return state.confirmBookingRoomInfo
  },
  myBookingList (state) {
    return state.myBookingList
  },
  currentBooking (state) {
    return state.currentBooking
  },
  roomList (state) {
    return state.roomList
  },
  calendar (state) {
    return state.calendar
  },
  localCalendar (state) {
    return state.localCalendar
  },
  zoneList (state) {
    return state.zoneList
  },
  myBookingStatus (state) {
    return state.myBookingStatus
  },
  myBookingQuota (state) {
    return state.myBookingQuota
  }
}
export const actions = {
  SEARCH_ROOM ({ commit }, query) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .searchAvailableRooms(query)
        .then((result) => {
          commit('ROOM_SEARCH_COMPLETED', {
            result,
            query
          })
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  SET_BOOKING_DATETIME ({ commit }, dateTime) {
    return new Promise((resolve) => {
      commit('BOOKING_DATETIME_SET', dateTime)
      resolve()
    })
  },
  SET_BOOKING_CAPACITY ({ commit }, capacity) {
    return new Promise((resolve) => {
      commit('BOOKING_CAPACITY_SET', capacity)
      resolve()
    })
  },
  SET_BOOKING_ROOMTYPE ({ commit }, roomType) {
    return new Promise((resolve) => {
      commit('BOOKING_ROOMTYPE_SET', roomType)
      resolve()
    })
  },
  CLEAR_SEARCH_RESULT ({ commit }) {
    return new Promise((resolve) => {
      commit('SEARCH_RESULT_CLEARED')
      resolve()
    })
  },
  SHOW_CONFIRM_BOOKING ({ commit }, { roomInfo, roomLayout }) {
    return new Promise((resolve) => {
      commit('CONFIRM_BOOKING_SHOWN', { roomInfo, roomLayout })
      resolve()
    })
  },
  GET_ROOM_LIST ({ commit }, zone) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .listRoom(zone)
        .then((result) => {
          commit('GET_ROOM_LIST_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  BOOK_ROOM ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .bookRoom(payload)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  CANCEL_BOOKING (ctx, bookingId) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .cancelBooking(bookingId)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_MY_BOOKINGS ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // const env = this.app.context.env
      api(this.app.context)
        .getMyBookings(payload)
        .then((result) => {
          /* let items = []
          if (env.IS_MIGRATED) {
            items = result.records || []
          } else {
            items = result.Records || []
          } */
          const items = result.results
          commit('GET_MY_BOOKING_SUCCESS', items)
          resolve(items)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_BOOKING ({ commit }, bookingId) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getBooking(bookingId)
        .then((result) => {
          console.log('GET_BOOKING_SUCCESS', result)
          commit('GET_BOOKING_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_CALENDAR ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getCalendar(payload)
        .then((result) => {
          commit('GET_CALENDAR_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_LOCAL_CALENDAR ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getCalendar(payload)
        .then((result) => {
          commit('GET_LOCAL_CALENDAR_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_ZONES ({ commit }) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getZoneList()
        .then((result) => {
          commit('GET_ZONES_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_MY_BOOKING_STATUS ({ commit }) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getMyBookingStatus()
        .then((result) => {
          commit('GET_MY_BOOKING_STATUS_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_MY_BOOKING_QUOTA ({ commit }) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getMyBookingQuota()
        .then((result) => {
          commit('GET_MY_BOOKING_QUOTA_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  }
}
export const mutations = {
  ROOM_SEARCH_COMPLETED (state, { result, query }) {
    // const preferPrivilege = state.myInfo.prefer_privilege
    // const hoursOfUse = preferPrivilege.hours_of_use || 0
    state.searchResult = result
    // transform date times
    let dateTime = query.timeSlots
    if (dateTime) {
      dateTime = query.timeSlots.split(',').map((text) => {
        // console.log('text', text)
        const ts = moment(decodeURIComponent(text)).tz(this.app.context.env.TIMEZONE)
        const endAt = ts.clone().add(2, 'hour')
        return `${ts.format('x')}_${endAt.format('x')}`
      })
    }
    // TODO Check if bug search display
    // state.searchQuery = {
    //   dateTime: dateTime || [],
    //   capacity: query.capacity || '',
    //   meetingRoom: query.roomType || 'ALL'
    // }
  },
  BOOKING_DATETIME_SET (state, dateTime) {
    if (state.searchQuery) {
      state.searchQuery.dateTime = dateTime
    }
  },
  BOOKING_CAPACITY_SET (state, capacity) {
    if (state.searchQuery) {
      state.searchQuery.capacity = capacity
    }
  },
  BOOKING_ROOMTYPE_SET (state, roomType) {
    if (state.searchQuery) {
      state.searchQuery.meetingRoom = roomType
    }
  },
  SEARCH_RESULT_CLEARED (state) {
    if (state.searchQuery) {
      state.searchQuery.dateTime = []
      state.searchQuery.capacity = ''
      state.searchQuery.meetingRoom = 'ALL'
    }
    state.searchResult = null
    state.confirmBookingRoomInfo = null
  },
  CONFIRM_BOOKING_SHOWN (state, roomDisplayItem) {
    state.confirmBookingRoomInfo = roomDisplayItem
  },
  GET_MY_BOOKING_SUCCESS (state, bookingList) {
    state.myBookingList = bookingList
  },
  GET_BOOKING_SUCCESS (state, bookingItem) {
    state.currentBooking = bookingItem
  },
  GET_ROOM_LIST_SUCCESS (state, roomList) {
    state.roomList = roomList
  },
  GET_CALENDAR_SUCCESS (state, result) {
    state.calendar = result
  },
  GET_LOCAL_CALENDAR_SUCCESS (state, result) {
    state.localCalendar = result
  },
  GET_ZONES_SUCCESS (state, result) {
    state.zoneList = result
  },
  GET_MY_BOOKING_STATUS_SUCCESS (state, bookingStatus) {
    state.myBookingStatus = bookingStatus
  },
  GET_MY_BOOKING_QUOTA_SUCCESS (state, bookingQuota) {
    state.myBookingQuota = bookingQuota
  }
}
